import type { ADF } from '@atlassian/jira-rich-content/src/model/adf.tsx';

export const getADFMarkup = async (node: ADF | null | string) => {
	if (node === null || node === undefined || typeof node === 'string') {
		return '';
	}

	const schemaPromise = import(
		/* webpackChunkName: "async-adf-defaultschema" */ '@atlaskit/adf-schema/schema-default'
	);
	const wikiPromise = import(
		/* webpackChunkName: "async-wikimarkup-transformer" */ '@atlaskit/editor-wikimarkup-transformer'
	);
	const jsonPromise = import(
		/* webpackChunkName: "async-json-transformer" */ '@atlaskit/editor-json-transformer'
	);

	const [{ defaultSchema }, { WikiMarkupTransformer }, { JSONTransformer }] = await Promise.all([
		schemaPromise,
		wikiPromise,
		jsonPromise,
	]);

	const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
	const adfTransformer = new JSONTransformer();

	const pmNode = adfTransformer.parse(node);
	return wikiTransformer.encode(pmNode);
};
